import colorModel from './../../../../model/color';
import equipmentModel from './../../../../model/equipment';
import equipmentFactoryModel from './../../../../model/equipmentFactory';
import makesModel from './../../../../model/makes';
import equipmentLevel from './../../../../model/equipmentLevel';
import Loading from './../misc/Loading';
import Model from './Model';
import models from '../../../../model/model';
import modelPageModel from '../../../../model/modelPage';
import update from 'immutability-helper';
import variantGroup from './../../../../model/variantGroup';
import variant from './../../../../model/variant';
import openGraphModel from '../../../../model/openGraph';
import React from 'react';
import ValidationError from '../../../../model/error/ValidationError';
import withRouter from '/src/components/misc/withRouter';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Nybilinformasjonen validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av nybilinformasjonen og handlingen kunne dermed ikke fullføres.';
};

class ModelContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      equipmentLevels: null,
      model: null,
      variants: null,
      variantGroups: null,

      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnArchive = this.handleUnArchive.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleColors = this.handleColors.bind(this);
    this.handlePageCreate = this.handlePageCreate.bind(this);
  }

  componentDidMount() {
    const modelId = this.props.match.params.id;

    if (modelId !== 'new') {
      Promise.all([
        models.getById(modelId, 2),
        variantGroup.variantGroupsByModel(modelId),
        variant.variantsByModel(modelId, 1),
        equipmentLevel.getByModelId(modelId),
        colorModel.getByModelId(modelId, 1),
        equipmentModel.getByModelId(modelId, 1),
        equipmentFactoryModel.getByModelId(modelId, 1),
        openGraphModel.getByTargetId(modelId)
      ]).then(([model, groups, variants, equipmentLevels, colors, equipments, equipmentFactory, opengraphs]) => {
        document.title = `Admin - Nybilinformasjon - ${model.name}`;
        if (model.equipmentFactoryOrderList) {
          // Sort by saved order on model (ids not in the model sort list will come last)
          equipmentFactory.sort((a, b) => {
            // If A is not in the sort list, B comes first
            if (model.equipmentFactoryOrderList.indexOf(a.id) === -1) {
              return 1;
            }

            // If B is not in the sort list, A comes first
            if (model.equipmentFactoryOrderList.indexOf(b.id) === -1) {
              return -1;
            }

            // Sort based on index of id
            return model.equipmentFactoryOrderList.indexOf(a.id) - model.equipmentFactoryOrderList.indexOf(b.id);
          });
        }

        // Try to sort equipment similar to frontend (category, pri)
        const eqCategories = [
          'Dekk',
          'Utvendig',
          'Innvendig',
          'Anbefalt tilbehør'
        ];
        equipments.sort((a, b) => {
          if (!a.category) {
            // No category, put a last
            return 1;
          }

          if (!b.category) {
            // No category, put b last
            return -1;
          }

          if (a.category === b.category) {
            // Same category, order on priority
            return b.priority - a.priority;
          }

          // Order categories by wanted order
          return eqCategories.indexOf(b.category) - eqCategories.indexOf(a.category);
        });

        this.setState({
          model: model,
          make: model.make,
          variantGroups: groups,
          variants: variants,
          equipmentLevels: equipmentLevels,
          colors: colors,
          equipments: equipments,
          equipmentFactory: equipmentFactory,
          opengraphs: opengraphs
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      Promise.all([
        models.initializeCustom(1),
        makesModel.getById(this.props.match.params.makeId, 1)
      ]).then(([model, make]) => {
        this.setState({
          model: model,
          make: make,
          variantGroups: [],
          variants: [],
          equipmentLevels: [],
          colors: [],
          equipments: [],
          equipmentFactory: []
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handlePageCreate() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    modelPageModel.new({}).then((newPage) => {
      const model = update(this.state.model, {
        pages: {
          $push: [newPage]
        }
      });

      this.setState({
        model: model
      });

      this.handleSave();
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.model.id;
    if (isCreate) {
      models.create({
        ...this.state.model,
        makeId: this.state.make.id
      }, 2).then((model) => {
        this.setState({
          working: false,
          model: model
        });
        this.props.history.push(`/modeller/${this.state.make.id}/modell/${model.id}`);
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      models.save(this.state.model, 2).then((model) => {
        this.setState({
          working: false,
          model: model
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handlePublish() {
    this.setState({
      working: true
    });
    models.publishWithBlocks(this.state.model, 2).then((model) => {
      this.setState({
        working: false,
        model: model
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      working: true
    });
    models.archive(this.state.model.id, 2).then((model) => {
      this.setState({
        working: false,
        model: model
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnArchive() {
    this.setState({
      working: true
    });
    models.unarchive(this.state.model.id, 2).then((model) => {
      this.setState({
        working: false,
        model: model
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    models.unpublish(this.state.model.id, 2).then((model) => {
      this.setState({
        working: false,
        model: model
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  handleColors(colorObj, modelId) {
    this.setState({
      working: true
    });
    colorModel.unpublish(colorObj.id, 2).then((color) => {
      Promise.all([
        colorModel.archive(color.id, 2),
        colorModel.getByModelId(modelId, 1)
      ]).then(([, colors]) => {
        this.setState({
          working: false,
          colors: colors
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  render() {
    if (!this.state.model) {
      return <Loading title="Modell" text="Laster modelldata" />;
    }

    return (
      <Model
        model={this.state.model}
        make={this.state.make}
        variantGroups={this.state.variantGroups}
        variants={this.state.variants}
        equipmentLevels={this.state.equipmentLevels}
        colors={this.state.colors}
        equipments={this.state.equipments}
        equipmentFactory={this.state.equipmentFactory}
        opengraphs={this.state.opengraphs}
        modified={this.state.modified}
        working={this.state.working}
        error={this.state.error}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.handlePublish}
        onArchive={this.handleArchive}
        onUnArchive={this.handleUnArchive}
        onUnpublish={this.handleUnpublish}
        onColorChange={this.handleColors}
        onPageCreate={this.handlePageCreate}
      />
    );
  }
}

ModelContainer.defaultProps = {
  id: null
};

export default withRouter(ModelContainer);
